import { useAnchorWallet } from "@solana/wallet-adapter-react";
import { PublicKey } from "@solana/web3.js";
import { FC, useState } from "react";
import { changeStatusBulk } from "../../api/users/user.api";
import { addBulkWhitelistings } from "../../solana/methods/whitelisting";
import { MESSAGE_TYPE } from "../../utils/constants";
import { createNotification } from "../../utils/helpers";
import Modal from "../Modal/Modal";

const AddBulkMembersModal: FC<{ closeModal?: () => void }> = ({
  closeModal,
}) => {
  const [addedPubkeys, setAddedPubkeys] = useState<string>();
  const [errorMessage, setErrorMessage] = useState();
  const wallet = useAnchorWallet();

  const saveWhitelistings = async () => {
    try {
      if (!addedPubkeys) {
        throw new Error("No entered pubkeys");
      }
      const pubkeys = addedPubkeys?.split(" ");
      const mappedPubkeys: PublicKey[] = [];
      pubkeys?.forEach((pk) => {
        try {
          mappedPubkeys.push(new PublicKey(pk.trim()));
        } catch (error) {
          throw new Error(`Invalid pubkey input for:${pk}`);
        }
      });
      if (wallet) {
        await addBulkWhitelistings(mappedPubkeys, wallet);
        await changeStatusBulk(pubkeys);
      }
      setErrorMessage(undefined);
      createNotification(
        MESSAGE_TYPE.SUCCESS,
        "Succesfully whitelisted members"
      );
      closeModal!();
    } catch (error: any) {
      setErrorMessage(error.message);
    }
  };

  return (
    <Modal closeModal={closeModal}>
      <h2>Add Whitelistings</h2>
      <textarea
        placeholder="Add pubkeys"
        style={{
          width: "100%",
          padding: "0.5em",
          minHeight: "10em",
          borderRadius: "5px",
          background: "rgba(10, 20, 40, 1)",
          border: "1px solid white",
          marginTop: "0.5em 0",
          color: "white",
        }}
        value={addedPubkeys}
        onChange={(e) => setAddedPubkeys(e.target.value)}
      />
      {errorMessage && (
        <p style={{ color: "#fd2b2b", fontSize: "0.8em" }}>{errorMessage}</p>
      )}
      <div
        style={{
          marginTop: "0.5em",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button
          onClick={closeModal}
          style={{
            background: "transparent",
            fontSize: "0.8em",
            fontWeight: "bold",
            border: "1px solid white",
            borderRadius: "5px",
            padding: "0.8em",
            color: "white",
            width: "8em",
          }}
        >
          Cancel
        </button>
        <button
          onClick={saveWhitelistings}
          style={{
            background: "#2bfda7",
            fontSize: "0.8em",
            fontWeight: "600",
            border: "none",
            borderRadius: "5px",
            padding: "0.8em",
            width: "8em",
          }}
        >
          Save
        </button>
      </div>
    </Modal>
  );
};

export default AddBulkMembersModal;
